export {default as testCard} from './test-card';
export {default as testUser} from './test-user';
export {default as countries} from './countries';
export {default as nationalities} from './nationalities';
export {default as locales} from './locales';
export {default as alger} from './app-conf/alger';
export {default as caribbean} from './app-conf/caribbean';
export {default as stbarthrental} from './app-conf/stbarthrental';

export const AVAIL_DATE_TIME_FORMAT = 'YYYY-MM-DD HH.mm.ss';
